import { BehaviorSubject, Observable, tap } from "rxjs";
import { Currency } from "app/core/models/currency.model";
import { environment } from "environments/environment";
import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";

@Injectable({
  providedIn: "root",
})
export class CurrencyService {
  private _apiUrl = environment.apiUrlPrefix;
  private _currenciesUrl = "Currencies";

  private _currencies: BehaviorSubject<Currency[] | null> = new BehaviorSubject(
    null,
  );

  constructor(private _httpClient: HttpClient) {}

  //================================================
  //? @GETTERS
  //================================================

  get currencies$(): Observable<Currency[]> {
    return this._currencies.asObservable();
  }

  //================================================
  //? @PUBLIC METHODS
  //================================================

  getCurrencies(): Observable<any> {
    return this._httpClient
      .get<any>(`${this._apiUrl}${this._currenciesUrl}`)
      .pipe(
        tap((response) => {
          response;
          this._currencies.next(response);
          return response;
        }),
      );
  }
}
